interface SEOSchemaProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SEOSchema({ type, data = {} }: SEOSchemaProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '纲手本子·高质量同人创作合集',
      url: 'https://tsunade-doujin.readdy.ai/',
      description: '专注于火影忍者纲手角色同人创作的内容聚合平台，汇集高质量纲手本子插画、漫画与同人故事。',
      foundingDate: '2024-01-01',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@tsunade-doujin.readdy.ai',
      },
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '纲手本子·高质量同人创作合集',
      url: 'https://tsunade-doujin.readdy.ai/',
      description: '汇聚高质量纲手本子插画、漫画与同人故事，满足资深火影粉丝对纲手角色的深度创作需求。',
      inLanguage: 'zh-CN',
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: data.name || '纲手本子·高质量同人创作合集',
      description: data.description || '汇聚高质量纲手本子插画、漫画与同人故事。',
      url: data.url || 'https://tsunade-doujin.readdy.ai/',
      inLanguage: 'zh-CN',
      isPartOf: {
        '@type': 'WebSite',
        name: '纲手本子·高质量同人创作合集',
        url: 'https://tsunade-doujin.readdy.ai/',
      },
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: data.headline || '',
      description: data.description || '',
      image: data.image || '',
      datePublished: data.datePublished || '',
      dateModified: data.dateModified || data.datePublished || '',
      author: {
        '@type': 'Person',
        name: data.author || '纲手本子同人创作平台',
      },
      publisher: {
        '@type': 'Organization',
        name: '纲手本子·高质量同人创作合集',
      },
      inLanguage: 'zh-CN',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: (data.questions as Array<{ question: string; answer: string }>)?.map((q) => ({
        '@type': 'Question',
        name: q.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: q.answer,
        },
      })) || [],
    },
  };

  const schema = schemas[type] || {};

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}